import React, {useContext, useEffect, useState} from "react";
import {authContext} from "../../context/authContext";
import {ce_default_url} from "../../context/firebase-config";

const PortfolioRenameForm = ({project, portfolioName, onClose, onSuccess, onError}) => {
    const user = useContext(authContext);
    const [formData, setFormData] = useState(new FormData());
    const [apiKey, setApiKey] = useState(null);
    const regex = /^[-a-zA-Z0-9_]{2,32}$/;

    useEffect(() => {
        user && user.getIdTokenResult()
            .then((token) => {
                if (!!token.claims.api_key) {
                    setApiKey(token.claims.api_key)
                } else {
                    console.error('api key not available for user')
                }
            })
    }, [user]);

    const handleChange = (event) => {
        const {name, value, files} = event.target;
        if (files) {
            formData.append(name, files[0]);
        } else {
            formData.append(name, value);
        }
        setFormData(new FormData(event.target.form));
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        const portfolio_name = formData.get('portfolio_name');
        if (!regex.test(portfolio_name)) {
            console.log(`Handling submit. Portfolio name not valid: ${portfolio_name}`);
            onError("Invalid portfolio name. Valid portfolio names are between 2 and 32 characters comprised of letters, numbers, underscores, hyphens, and no spaces.")
            onClose()
            return;
        }
        const url = `${ce_default_url}/api/portfolios/${portfolioName}/rename`;
        const data = {
            "portfolio_name": portfolio_name,
        }
        fetch(url, {
            method: 'POST',
            headers: {
                'X-SustGlobal-APIKey': apiKey,
                'X-SustGlobal-Project': `${project}`,
            },
            body: JSON.stringify(data)
        })
            .then((response) => {
                console.log(response.data);
                onSuccess('portfolio successfully renamed')
            })
            .catch((error) => {
                console.error(`could not rename portfolio: ${error}`)
                onError(`could not rename portfolio: ${error}`)
            })
            .finally(() => {
                onClose()
            })
    }

    return (
        <form onSubmit={(event) => handleSubmit(event)}>
            <div className="modal-header bg-black" style={{border: "1px solid grey"}}>
                <h5 className={"modal-title"} style={{color: "#ffffff"}}>Rename Portfolio</h5>
                <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body form-group bg-black" style={{border: "1px solid grey"}}>
                <p className="mb-1" style={{color: "#ffffff", fontWeight: "455", fontSize: "1rem"}}>Portfolio Name</p>
                <input className="form-control" type="input" name="portfolio_name" placeholder={`${portfolioName}`}
                       pattern="^[-a-zA-Z0-9_]{2,32}$" required="" onChange={handleChange}/>
                <p style={{color: "#808080", fontWeight: "400"}}>
                    <small>Valid portfolio names are between 2 and 32 characters comprised of letters, numbers,
                        underscores, hyphens, and no spaces.</small>
                </p>
                <p style={{color: "#808080", fontWeight: "400"}}>
                    <small>The <a target="_blank" href="https://developers.sustglobal.com/user-guide">Sust Global
                        Developer Center</a> contains additional resources that may assist in this process.</small>
                </p>
            </div>
            <div className="modal-footer bg-black" style={{border: "1px solid grey"}}>
                <button className={"btn btn-primary"} type="submit">Submit</button>
                <button className={"btn btn-secondary"} onClick={onClose}>Close</button>
            </div>
        </form>
    );
}

export default PortfolioRenameForm;